import { documentStore } from "@/store/store";
import { findNode } from "@/lib/tree/tree";
import { getPromptInfoFromNode } from "@/lib/singularity/util";
import { logEvent } from "@/util/tracking";

export function logSectionRewriteClick(nodeId: string) {
  const node = findNode(documentStore.document.tree, nodeId);
  if (!node) return;

  const promptInfo = getPromptInfoFromNode(node);

  const eventData: any = {
    sectionType: promptInfo?.singularity.sectionData.type || "unknown"
  };

  logEvent("FutureLayer Section Rewrite Click", eventData);
}
